import React, {useEffect, useState} from 'react';
import HeaderService from "../../../../../../API/orders/orders/organization/HeaderService";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import TextFieldWithSetValue from "../../../../textfield/TextFieldWithSetValue";
import TextFieldObjectWithEntityList from "../../../../textfield/TextFieldObjectWithEntityList";
import OrderDatePicker from "../../../../datepicker/OrderDatePicker";
import MaterialTextFieldObjectWithEntityList from "../../../../modul/mainoptions/MaterialTextFieldObjectWithEntityList";
import {orderStatus} from "../../../../../../data/OrderStatus";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import MainOptionsMaterialModuleEntityTextField
    from "../../../../modul/mainoptions/MainOptionsMaterialModuleEntityTextField";

const UpdateOrderModal = ({
                              open,
                              onClose,
                              onSubmit,
                              values,
                              setValues,
                              dateOfReceipt,
                              setDateOfReceipt,
                              dateOfPlannedProduction,
                              setDateOfPlannedProduction,
                              plannedDateOfShipment,
                              setPlannedDateOfShipment,
                              manufactured,
                              setManufactured,
                              shipped,
                              setShipped,
                              handleModalAlert,
                              forWriteOff,
                              loading
                          }) => {
    const [modelHeaderList, setModelHeaderList] = useState([]);
    const [modelHeaderId, setModelHeaderId] = useState(null);

    useEffect(() => {
        HeaderService.getAllUnable().then(function (response) {
            const data = response.data;
            setModelHeaderList(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleClose = () => {
        setValidationState({header: "", manufactured: "", shipped: ""})
        onClose()
    }
    const currentStatus = values?.status;
    const delta = currentStatus === "NEW" ? 0 : 1
    const statusesToExclude = forWriteOff ? [] : Object.keys(orderStatus).slice(0, Object.keys(orderStatus).indexOf(currentStatus) - delta);
    statusesToExclude.push('ARCHIVE');

    const filteredOrderStatus = Object.fromEntries(
        Object.entries(orderStatus).filter(([key]) => !statusesToExclude.includes(key))
    );

    const handleSubmit = () => {
        const newErrors = {...validationState}

        Object.entries(values).forEach(([name, value]) => {
            if (name === "header" && value === null || value === undefined) {
                newErrors[name] = "пустое поле"
            } else if (name === "shipped" && values?.status === "SHIPPED" && value === null && shipped === null) {
                newErrors[name] = "введите дату"
            } else if (name === "manufactured" && values?.status === "PRODUCED" && value === null && manufactured === null) {
                newErrors[name] = "введите дату"
            }
        })
        setValidationState(newErrors)
        if (Object.values(newErrors).every(el => el === "")) {
            values.dateOfReceipt = dateOfReceipt === null ? null : DateTimeUtil.dateConvert(dateOfReceipt);
            values.dateOfPlannedProduction = dateOfPlannedProduction === null ? null : DateTimeUtil.dateConvert(dateOfPlannedProduction);
            values.plannedDateOfShipment = plannedDateOfShipment === null ? null : DateTimeUtil.dateConvert(plannedDateOfShipment);
            values.manufactured = manufactured === null ? null : DateTimeUtil.dateConvert(manufactured);
            values.shipped = shipped === null ? null : DateTimeUtil.dateConvert(shipped);
            onSubmit(values,
                modelHeaderId === null ? values.header?.id : modelHeaderId,
            );
            handleClose();
        }
    };
    const [validationState, setValidationState] = useState({header: "", manufactured: "", shipped: ""})
    const setId = (type, id) => {
        setValues(prev => ({...prev, [type]: {id: id}}))
        setModelHeaderId(id)
    }

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Редактировать заказ</DialogTitle>
            <DialogContent sx={{padding: "40px 24px"}}>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                        }}
                    >
                        <TextFieldWithSetValue
                            label="Номер заказа"
                            values={values}
                            setValues={setValues}
                            field={'number'}
                        />
                        <TextFieldWithSetValue
                            label="Номер заказчика"
                            values={values}
                            setValues={setValues}
                            field={'numberCustomer'}
                        />
                        <MainOptionsMaterialModuleEntityTextField
                            label={'Наименование'}
                            values={values}
                            field={'header'}
                            childFirstField={'id'}
                            setId={(id) => setId("header", id)}
                            entityList={modelHeaderList}
                            validationError={validationState?.header}
                            setValidationState={setValidationState}
                        />
                        <OrderDatePicker
                            label={'Дата поступления'}
                            date={dateOfReceipt}
                            setDate={setDateOfReceipt}
                        />
                        <MaterialTextFieldObjectWithEntityList
                            label="Статус"
                            values={values}
                            setValues={setValues}
                            field={'status'}
                            entityList={filteredOrderStatus}
                        />
                        <OrderDatePicker
                            label={'Плановая дата производства'}
                            date={dateOfPlannedProduction}
                            setDate={setDateOfPlannedProduction}
                        />
                        <OrderDatePicker
                            label={'Произведено'}
                            field={"manufactured"}
                            date={manufactured}
                            setDate={setManufactured}
                            validationError={validationState?.manufactured}
                            setValidationState={setValidationState}
                        />
                        <OrderDatePicker
                            label={'Плановая дата отгрузки'}
                            date={plannedDateOfShipment}
                            setDate={setPlannedDateOfShipment}
                        />
                        <OrderDatePicker
                            label={'Отгружено'}
                            date={shipped}
                            field={"shipped"}
                            setDate={setShipped}
                            validationError={validationState?.shipped}
                            setValidationState={setValidationState}
                        />
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выход"} onClick={handleClose}/>
                <ButtonAdd loading={loading} text={"Сохранить"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateOrderModal;